import { LitElement, html } from 'lit';
import { pluralize } from '../fit-polyglot/fit-polyglot-behavior';
import styles from './fit-search-results-count.css';

class FitSearchResultsCount extends LitElement {
  static get is() {
    return 'fit-search-results-count';
  }

  render() {
    return html`
        <p ?visible="${this.total > 0}">${pluralize(this.labels.ResultsFound, this.total)}</p>`;
  }

  static get styles() { return styles; }

  static get properties() {
    return {
      total: {
        type: Number,
      },

      labels: {
        type: Object,
      },
    };
  }

  constructor(props) {
    super(props);
    this.total = 0;

    this.updateTotal = this.updateTotal.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this._fitSearch = document.querySelector('fit-search');
    if (this._fitSearch) {
      this._fitSearch.addEventListener('fit-search-first-page', this.updateTotal);
      if (!this._fitSearch.loading && this._fitSearch.total) {
        this.total = this._fitSearch.total;
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._fitSearch) {
      this._fitSearch.removeEventListener('fit-search-first-page', this.updateTotal);
    }
  }

  updateTotal(event) {
    this.total = event.target.total;
  }
}

customElements.define(FitSearchResultsCount.is, FitSearchResultsCount);
